import type {
  DeletedCIsResponse,
  DeletePolicyRequest,
  DeletePolicyResponse,
  DeletePolicyWithParentResponse,
  MarkAllCIsPreviewResponse,
  MarkedCIsResponse,
} from '@/entities/srm/ci';
import type { AxiosRequestConfig } from 'axios';
import { srmInstance } from '@/shared/api/api-instances/srm/api-instance';

export class DeletePoliciesAPI {
  static getDeletePolicy(cit_id: string, options: AxiosRequestConfig = {}) {
    return srmInstance.get<DeletePolicyResponse>(
      `/delete_policy/${cit_id}`,
      options,
    );
  }

  static getDeletePolicyWithParent(
    cit_id: string,
    options: AxiosRequestConfig = {},
  ) {
    return srmInstance.get<DeletePolicyWithParentResponse>(
      `/delete_policy/${cit_id}/with_parent`,
      options,
    );
  }

  static updateDeletePolicy(
    cit_id: string,
    payload: DeletePolicyRequest,
    options: AxiosRequestConfig = {},
  ) {
    return srmInstance.put<DeletePolicyResponse>(
      `/delete_policy/${cit_id}`,
      payload,
      options,
    );
  }

  static deleteMarkedCIs(
    cit_id: string,
    with_children: boolean,
    options: AxiosRequestConfig = {},
  ) {
    return srmInstance.delete<DeletedCIsResponse>(
      `/delete_policy/${cit_id}/marked_cis`,
      { ...options, params: { with_children, ...options.params } },
    );
  }

  static getMarkAllCIsPreview(
    cit_id: string,
    options: AxiosRequestConfig = {},
  ) {
    return srmInstance.get<MarkAllCIsPreviewResponse>(
      `/delete_policy/${cit_id}/all_cis/preview`,
      options,
    );
  }

  static markAllCIs(
    cit_id: string,
    with_children: boolean,
    confirm_name: string,
    options: AxiosRequestConfig = {},
  ) {
    return srmInstance.delete<MarkedCIsResponse>(
      `/delete_policy/${cit_id}/all_cis`,
      {
        ...options,
        params: { with_children, confirm_name, ...options.params },
      },
    );
  }
}